import { EventEmitter } from '@angular/core';

export interface GpsUpdateTimerOptions {
	updateCallback: () => void;
	interval?: number;
}

/**
 * Timer-Klasse für GPS-Tracking Updates.
 */
export class GpsUpdateTimer {
	private timer: ReturnType<typeof setInterval> | null = null;
	private _isUpdating = false;
	private updateCallback: () => void;
	private interval: number;

	public readonly toggled = new EventEmitter<boolean>();

	constructor(options: GpsUpdateTimerOptions) {
		this.updateCallback = options.updateCallback;
		this.interval = options.interval ?? 10000;
	}

	isUpdating(): boolean {
		return this._isUpdating;
	}

	startUpdating(): void {
		if (this._isUpdating) return;

		this._isUpdating = true;
		this.toggled.emit(true);

		this.updateCallback();

		this.timer = setInterval(() => {
			this.updateCallback();
		}, this.interval);
	}

	stopUpdating(): void {
		if (!this._isUpdating) return;

		this._isUpdating = false;
		this.toggled.emit(false);

		if (this.timer) {
			clearInterval(this.timer);
			this.timer = null;
		}
	}

	toggleUpdating(): void {
		if (this._isUpdating) {
			this.stopUpdating();
		} else {
			this.startUpdating();
		}
	}

	updateNow(): void {
		this.updateCallback();
	}

	destroy(): void {
		this.stopUpdating();
	}
}
